import React from 'react';
import './layout.scss';
import PageControls from '../navigation/PageControls';
import LearnMoreModal from './LearnMoreModal';

function PageHeader(props){
  return(
    <div>
      {props.majorHeading
        ? <h1 className="aa-major-heading">{props.majorHeading}</h1>
        : null
      }
      {props.title
        ? <h3 className="aa-page-title">{props.title}</h3>
        : null
      }
      {props.subTitle
        ? <p className="aa-page-subtitle">{props.subTitle}</p>
        : null
      }
    </div>
  );
}
  
// Presentational component to display the main page section.
// Bootstrap notes:
// PageSection fills in the rest of the width ("col"), with 2 empty cols right on large+ screen widths ("col-lg-2").
// Add ml-md-2 to page-section div (For med+, set margin-left to 2) to experiment with gap between columns.
//Note: if main div is set to 10 column width ("col-md-10") instead of "col", the ms margin pushes it below the sidebar (breaks the grid). 

function PageSection(props) {
    //the extra container div adds a bit of padding left and right.
    //font-awesome is currently hardwired stand-in for props-based image.
    //if no font-awesome icon provided, don't save room for it.
    
    //by default, give a right margin column. otw follow directive of props.rightMargin
    const rightMargin = (props.page.rightMargin === undefined) ? true : props.page.rightMargin;
    const pageSectionClassName = (props.page.pageSectionClassName === undefined) ? "" : props.page.pageSectionClassName;
    const pageSymbolClassName = (props.page.pageSymbolClassName === undefined) ? "" : props.page.pageSymbolClassName;

    return(
      <div className="col aa-page-section" role="main">
        <div className="container-fluid">
          <div className={`row ${pageSectionClassName}`}>
            {/* {props.page.faIcon && <div className="col-lg-1">
                <span className={`fa ${props.page.faIcon} fa-4x aa-fa-display-only`}></span>
            </div>} */}
            
            {pageSymbolClassName && 
              <div className={`col-lg-1 ${pageSymbolClassName}`}></div>}

            <div className="col">
              <PageHeader 
                majorHeading={props.page.majorHeading} 
                title={props.page.title} 
                subTitle={props.page.subTitle} 
              />
              <div>
                {props.contentComponent}
              </div>
              <div>
                <LearnMoreModal 
                  linkText={props.page.learnMore.linkText} 
                  title={props.page.learnMore.title} 
                  content={props.page.learnMore.content} 
                />
              </div>
            </div>
            {rightMargin && <div className="col-lg-2 col-xl-3"></div>}
          </div>
          <div className="row">
            <div className="col">
            <PageControls
              backName={props.page.backName ? props.page.backName : undefined}
              continueName={props.page.continueName ? props.page.continueName : undefined}
              nextRoute={props.page.nextRoute} 
              continueDisabled={props.page.continueDisabled}
              onContinue={props.onContinue}/>
            </div>
            {rightMargin && <div className="col-lg-2 col-xl-3"></div>}
          </div>
        </div>
      </div>
    );
  }
  
  export default PageSection;
